import "../../global.css";
import "./productList.css";
import "./importProducts.css";
import "../config/paleta";
import CustomGrid from "../../components/grid/CustomGrid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../redux/apiCalls";
import { useState } from "react";
import * as XLSX from "xlsx";
import { userRequest } from "../../requestMethods";
import Swal from "sweetalert2";
import { formatPricing, _removerAcentos } from "../../util/helper";
import { buildImportPayload } from "../../util/importProducts";
import Loading from "../../components/loading/loading";
import { useCompany } from "../../components/context/CompanyContext";
import { generateFileUrl } from "../../requestMethods";
import Button from "@mui/material/Button";

export default function ImportProducts() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [dataXLS, setDataXLS] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { companyId } = useCompany();

  useEffect(() => {
    getProducts(dispatch, true, companyId);
  }, [dispatch, companyId]);

  useEffect(() => {}, [dataXLS]);

  const columns = [
    {
      field: "productId",
      headerName: "ID Produto",
      width: 1,
      align: "left",
      hideable: false,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "title",
      align: "left",
      headerName: "Produto",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "ref",
      headerName: "Referência",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "shortDesc",
      headerName: "Descrição Curta",
      width: 200,
      align: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "desc",
      headerName: "Descrição",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "price",
      headerName: "Preço com desconto",
      width: 160,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    {
      field: "discount",
      headerName: "Preço",
      width: 200,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    {
      field: "colors",
      headerName: "Cores",
      width: 200,
      headerClassName: "dataGridMuiHeader",
      align: "left",
    },
    {
      field: "sizes",
      headerName: "Tamanhos",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "category",
      headerName: "Categoria",
      headerClassName: "dataGridMuiHeader",
      width: 200,
      align: "left",
    },
    {
      field: "subCategory",
      headerName: "Subcategoria",
      width: 200,
      align: "left",
      headerClassName: "dataGridMuiHeader",
    },
  ];

  const addXLS = async () => {
    setIsLoading(true);
    if (dataXLS.length > 0) {
      const { products: product, invalidRows } = buildImportPayload(
        dataXLS,
        currentUser.userId
      );

      if (product.length === 0) {
        setIsLoading(false);
        Swal.fire(
          "Atenção!",
          "Nenhuma linha válida: informe Produto, Referência e Preço.",
          "warning"
        );
        return;
      }

      const res = await userRequest.post(
        `${companyId}/products/import`,
        product
      );

      if (Object.keys(res.data).length > 0) {
        const aviso = invalidRows.length
          ? ` ${invalidRows.length} linha(s) ignorada(s) por falta de Produto, Referência ou Preço (linha ${invalidRows
              .map((row) => row.line)
              .join(", ")}).`
          : "";
        Swal.fire(
          "Parabéns!",
          `Produtos adicionado com sucesso!${aviso}`,
          "success"
        );
      }
    } else {
      Swal.fire("Atenção!", "Favor selecionar um aquivo!", "warning");
    }
    setIsLoading(false);
  };

  const handleFileUpload = (e) => {
    setIsLoading(true);
    const reader = new FileReader();
    reader.readAsBinaryString(e.target.files[0]);
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });

      if (validaFile(workbook)) {
        const index = workbook.SheetNames.findIndex(
          (item) => item === "Produtos"
        );
        const sheetName = workbook.SheetNames[index];
        const sheet = workbook.Sheets[sheetName];

        sheet["A1"].w = "title";
        sheet["B1"].w = "ref";
        sheet["C1"].w = "shortDesc";
        sheet["D1"].w = "desc";
        sheet["E1"].w = "price";
        sheet["F1"].w = "discount";
        sheet["G1"].w = "category";
        sheet["H1"].w = "subCategory";
        sheet["I1"].w = "sizes";
        sheet["J1"].w = "colors";

        const parsedData = XLSX.utils.sheet_to_json(sheet, { raw: false });
        const newParseData = parsedData.map((item) => ({
          title: item.title ? item.title.toUpperCase() : null,
          ref: item.ref ? item.ref.replace(",", ".").toUpperCase() : null,
          shortDesc: item.shortDesc ? item.shortDesc.toUpperCase() : null,
          desc: item.desc ? item.desc.toUpperCase() : null,
          price: item.price ? item.price : item.discount,
          discount: item.discount,
          category: item.category ? item.category.toUpperCase() : null,
          subCategory: item.subCategory ? item.subCategory.toUpperCase() : null,
          sizes: item.sizes ? _removerAcentos(item.sizes.toUpperCase()) : null,
          colors: item.colors
            ? _removerAcentos(item.colors.toUpperCase())
            : null,
        }));
        setDataXLS(newParseData);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        Swal.fire("Erro!", "Estrutura do arquivo modificada.", "warning");
      }
    };
    setIsLoading(false);
  };

  const validaFile = (workbook) => {
    const index = workbook.SheetNames.findIndex((item) => item === "Produtos");
    const sheetName = workbook.SheetNames[index];
    const sheet = workbook.Sheets[sheetName];

    if (index === -1) {
      return false;
    }
    if (sheet["A1"].v !== "Produto") {
      return false;
    }
    if (sheet["B1"].v !== "Referencia") {
      return false;
    }
    if (sheet["C1"].v !== "Breve Descrição") {
      return false;
    }
    if (sheet["D1"].v !== "Descrição") {
      return false;
    }
    if (sheet["E1"].v !== "Preço com desconto") {
      return false;
    }
    if (sheet["F1"].v !== "Preço") {
      return false;
    }
    if (sheet["G1"].v !== "Categoria") {
      return false;
    }
    if (sheet["H1"].v !== "Subcategoria") {
      return false;
    }
    if (sheet["I1"].v !== "Tamanhos") {
      return false;
    }
    if (sheet["J1"].v !== "Cores") {
      return false;
    }

    return true;
  };
  let downalodFIle = generateFileUrl("ImportFiles/ImportarProdutos.xlsx");
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-toolbar">
            <input id="selecao-arquivo" type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
            <Button size="small" variant="contained" color="secondary" onClick={addXLS}>
              Importar Excel
            </Button>
            <a href={downalodFIle} download style={{ fontSize: "13px" }}>Download Modelo</a>
          </div>
          <div className="cust-title">Importar Produtos</div>
          <div className="cust-card">
            <div className="cust-section-header">Informações para importação</div>
            <div style={{ padding: "16px", fontSize: "13px", color: "#555" }}>
              <p>1. O arquivo deve ser utilizado na mesma estrutura de download.</p>
              <p>2. As numerações e cores informadas no arquivo deverão ser da grade e cores selecionados nas configurações de <a href={`colorsize`}>tamanhos e cores</a>. Caso a numeração não exista, favor falar com nosso suporte.</p>
            </div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="importProducts"
                getRowId={(row) => row.title + row.ref}
                rows={dataXLS}
                columns={columns}
                pageSize={8}
                tableHeight="500px"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
